import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader, setCookie } from "../Helpers";
import { STR_CONTACT_US, STR_LOGOUT } from "../Strings";
import { MdLogout, MdPayments, MdSupportAgent, MdVerified } from 'react-icons/md';
import { LiaUserSolid } from "react-icons/lia";

export default function View(props) {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await appContext.getCurrentUserData();
    setReady(true);
  }

  function logOut() {
    appContext.setShowOverlayLoader(true);
    setCookie('userId', "", -10000000);
    setCookie('userToken', "", -10000000);
    appContext.navTo({
      item: '',
    })
    appContext.refresh();
    appContext.setShowOverlayLoader(false);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
          paddingBottom: "calc(var(--topBarHeight) + 40px)",
        }}
        className="mNoScrollBar"
      >
        <div className="container">
          <div className="row">

            <div className="col-md-12 text-center">
              <div className="card">
                <div className="card-body">
                  <h1 className="text-secondary">
                    <LiaUserSolid size={100} />

                    <span
                      style={{
                        display: "block",
                        fontSize: "22px"
                      }}
                      className="font-semi-bold"
                    >
                      {appContext.currentUserData.fullname || "LandLink User"}
                      {(appContext.currentUserData.isVerified === 'yes') ? <MdVerified className="text-primary ms-1" size={18}/> : ""}
                    </span>

                    <span
                      style={{
                        display: "block",
                        fontSize: "14px"
                      }}
                      className="font-regular text-muted mt-2"
                    >
                      +{appContext.currentUserData.phone}
                    </span>
                  </h1>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="card">
                <div className="card-body">

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{ padding: "0", cursor: "pointer" }}
                    onClick={() => appContext.navTo({ item: 'account', subItem: 'my-payments' })}
                  >
                    <MdPayments className="align-self-center mNoMargin" size={24} />
                    <h6 className="mNoMargin align-self-center font-semi-bold" style={{ fontSize: "14px", paddingLeft: "20px" }}>
                      {appContext.language === 'sw' ? 'Malipo yangu' : 'My payments'}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{ padding: "0", cursor: "pointer" }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'contact_us',
                      })
                    }}
                  >
                    <MdSupportAgent className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{ fontSize: "14px", paddingLeft: "20px" }}
                    >
                      {STR_CONTACT_US[appContext.language]}
                    </h6>
                  </div>

                  

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{ padding: "0", cursor: "pointer" }}
                    onClick={() => {
                      appContext.activateDialog({
                        message: STR_LOGOUT[appContext.language] + "?",
                        onConfirm: logOut,
                      })
                    }}
                  >
                    <MdLogout className="align-self-center mNoMargin" size={24} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{ fontSize: "14px", paddingLeft: "20px" }}
                    >
                      {STR_LOGOUT[appContext.language]}
                    </h6>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{ width: "100%", height: "100%" }}
      >
        {getInlineLoader()}
      </div>
    );
  }
}
